import React, { useState } from 'react'
import classNames from 'classnames'

import style from './TmoSelect.module.css'

function TmoSelect({
  className,
  onChange,
  value,
  selectSpecs: { options } = {},
  defaultValue,
  type,
  testId,
  ...rest
}) {
  const [val, setVal] = useState(value)
  const handleChange = (e) => {
    onChange(e.target.value)
    setVal(e.target.value)
  }

  return (
    <select
      className={classNames(type === "primary-select" ? style.select_primary : style.input, style.select, className)}
      onChange={handleChange}
      value={val}
      data-testid={testId}
      {...rest}
    >
      {options?.map((option) => (
        <option
          key={option.value}
          value={option.value}
          disabled={option.disabled}
        >
          {option.text || option.value}
        </option>
      ))}
    </select>
  )
}

export default TmoSelect
